/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'dashboard-core/js/lib/@waca/core-client/js/core-client/ui/ProgressToast'
], function (ProgressToast) {

	class Glass {
		glassFeature = {

		};
		constructor(glassContext) {
			this._glassContext = glassContext;
			this._glassFeature = null;
		}
		getAPI(type) {
			if (type === 'internal'){
				return {
					getGlassContext: () => this._glassContext
				};
			}
			if(!this._glassFeature){
				this._glassFeature = {
					showErrorMessage: (message, title) => {
						return this._glassContext.appController.showErrorMessage(message, title);
					},
					showMessage: (msg, title, type, buttons, width, callback, htmlContent, className) => {
						return this._glassContext.appController.showMessage(msg, title, type, buttons, width, callback, htmlContent, className);
					},
					showToast: (message, options) => {
						return this._glassContext.appController.showToast(message, options);
					},
					showProgressToast: (message, options) => {
						const progressToast = new ProgressToast(options);
						progressToast.show(message);
						return {
							fail: (message) => {progressToast.fail(message);},
							indefinite: (message) => {progressToast.indefinite(message);},
							hideButton: (button) => {progressToast.hideButton(button);},
							showButton: (button) => {progressToast.showButton(button);},
							setComplete: (percent, options) => {return progressToast.setComplete(percent, options);},
							onCancel: (callback) => {progressToast.onCancel(callback);},
							onHide: (callback) => {progressToast.onHide(callback);},
							remove: (delay) => {return progressToast.remove(delay);}
						};
					},
					showSlideOut: (options) => {
						return this._glassContext.appController.showSlideOut(options);
					},
					showContextMenu: (options) => {
						return this._glassContext.appController.showContextMenu(options);
					},
					isDevInstall: () => {
						return this._glassContext.isDevInstall();
					},
					openApplication: (name, options) => {
						return this._glassContext.appController.openAppView(name, options);
					},
					closeApplication: (name, id, options) => {
						return this._glassContext.appController.closeAppView(name, id, options);
					},
					getService: (name) => {
						return this._glassContext.getSvc(name);
					},
					getCoreService: (name) => {
						return this._glassContext.getCoreSvc(name);
					},
					getPlugin: (name) => {
						return this._glassContext.appController.findPlugin(name);
					},
					prepareGlassOptions: (options) => {
						options.glassContext = this._glassContext;
					}
				};
			}
			return this._glassFeature;
		}
	}
	return Glass;
});
